import {
  APPROVE_PENDING_DRUGS,
  APPROVE_PENDING_DRUGS_SUCCESS,
  APPROVE_PENDING_DRUGS_FAIL,
  REJECT_PENDING_DRUGS,
  REJECT_PENDING_DRUGS_SUCCESS,
  REJECT_PENDING_DRUGS_FAIL,
  SET_DRUG_PENDING_FILTER,
} from '../actions/pending.actions';

const initialState = {
  loading: false,
  error: null,
  filter: {
    textSearch: '',
  },
};

const pendingReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPROVE_PENDING_DRUGS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case APPROVE_PENDING_DRUGS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case APPROVE_PENDING_DRUGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case REJECT_PENDING_DRUGS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case REJECT_PENDING_DRUGS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case REJECT_PENDING_DRUGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case SET_DRUG_PENDING_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.payload.filter,
        },
      };
    default:
      return state;
  }
};

export default pendingReducer;
